// src/components/TermsOfService.js

import React from 'react';
import './TermsOfService.css'; // Optional: Import CSS for styling

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <h1>Terms of Service</h1>
      
      <section className="introduction">
        <h2>1. Introduction</h2>
        <p>
          Welcome to [Your Company Name]! By accessing or using our service, you agree to comply with and be bound by the following terms and conditions.
        </p>
      </section>

      <section className="user-obligations">
        <h2>2. User Obligations</h2>
        <p>
          Users are expected to use the service responsibly and not engage in any prohibited activities.
        </p>
      </section>

      <section className="intellectual-property">
        <h2>3. Intellectual Property</h2>
        <p>
          All content provided on this platform is the property of [Your Company Name] and is protected by applicable intellectual property laws.
        </p>
      </section>

      <section className="termination">
        <h2>4. Termination</h2>
        <p>
          We reserve the right to terminate or suspend access to our service without prior notice for any reason.
        </p>
      </section>

      <section className="disclaimer">
        <h2>5. Disclaimer</h2>
        <p>
          The service is provided "as is" without any warranties, express or implied.
        </p>
      </section>

      <section className="limitation-of-liability">
        <h2>6. Limitation of Liability</h2>
        <p>
          In no event shall [Your Company Name] be liable for any indirect, incidental, or consequential damages.
        </p>
      </section>

      <section className="governing-law">
        <h2>7. Governing Law</h2>
        <p>
          These terms shall be governed and construed in accordance with the laws of [Your Jurisdiction].
        </p>
      </section>

      <section className="changes-to-terms">
        <h2>8. Changes to Terms</h2>
        <p>
          We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of the updated terms.
        </p>
      </section>

      <section className="contact-information">
        <h2>9. Contact Information</h2>
        <p>
          If you have any questions about these Terms, please contact us at [Your Contact Information].
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;